import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, } from "@/components/ui/dialog";
import { decodeHTMLEntity } from "@/lib/utils";
import { Button } from "@/components/ui/button";
export default function FloorplanVirtualTourDialog(_a) {
    var floorplan = _a.floorplan;
    return (React.createElement(Dialog, null,
        React.createElement(DialogTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", className: "w-full text-center", size: "sm" }, "Virtual Tour")),
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Virtual Tour"),
                React.createElement(DialogDescription, null, decodeHTMLEntity(floorplan.title))),
            floorplan.virtualTourEmbedCode ? (React.createElement("div", { className: "min-h-[60vh] w-full [&>iframe]:aspect-video", dangerouslySetInnerHTML: {
                    __html: floorplan.virtualTourEmbedCode,
                } })) : (React.createElement("div", { className: "text-center py-6" },
                React.createElement("p", null, "No virtual tour available"))))));
}
